import styled from "styled-components";

export const AppLayoutWrapper = styled.div``;

export const AppContentWrapper = styled.div`
`;